import React, { useState, useEffect } from 'react';
import useCurrentPath from 'frontend/hooks/useCurrentPath';
import { ROUTE_KEYS } from 'frontend/constants';
import store from '../../../../storeClient';
import LoadSpinner from 'frontend/commons/spinner';

const BillboardImage = ({ image = '', pathname = '', routesToRenderFullPackageSearch = [] }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [imageError, setImageError] = useState(false);
  const shouldRenderFullHeight = routesToRenderFullPackageSearch.includes(pathname);

  // Safely get headerImagen from store with error handling
  const getHeaderImagen = () => {
    try {
      const state = store.getState();
      return state?.applicationState?.templateData?.headerImagen?.[0]?.valor || null;
    } catch (error) {
      console.error('Error accessing store:', error);
      return null;
    }
  };

  const headerImagen = getHeaderImagen();
  const imageUrl = headerImagen || image;
  const { isOnTargetPath } = useCurrentPath([ROUTE_KEYS.HOME, ROUTE_KEYS.BUSCAR_X_PAQUETES]);

  useEffect(() => {
    // Reset states when headerImagen changes
    if (headerImagen) {
      setIsLoading(true);
      setImageError(false);
    } else {
      // If no headerImagen, use default image immediately
      setIsLoading(false);
      setImageError(true);
    }
  }, [headerImagen]);

  const handleImageLoad = () => {
    setIsLoading(false);
    setImageError(false);
  };

  const handleImageError = () => {
    setImageError(true);
    setIsLoading(false);
  };

  return (
    <div className="billboard__container" style={{ aspectRatio: '16/9' }}>
      {isLoading && (
        <div
          className="loading-container"
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#f5f5f5',
          }}
        >
          <LoadSpinner />
        </div>
      )}
      <img
        className={`background__billboard ${
          shouldRenderFullHeight ? 'full-height' : 'partial-height'
        }`}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: isLoading ? 'none' : 'block',
        }}
        src={imageError ? image : imageUrl}
        alt="Billboard background"
        onLoad={handleImageLoad}
        onError={handleImageError}
      />
    </div>
  );
};

export default BillboardImage;
